import { CellControllerKind } from 'entities/TableControllers';

import { TableCellController } from './TableCellController';
import { TableDateController } from './TableDateController';
import { TableInputStringController } from './TableInputStringController';
import { TableNavigationController } from './TableNavigationController';
import { TableProgressBarController } from './TableProgressBarController';
import { TableSelectController } from './TableSelectController';
import { TableSwitchController } from './TableSwitchController';
import { TableTextController } from './TableTextController';

export const isTextControllerEntity = (
  controller: TableCellController['controller']
): controller is TableTextController =>
  controller.controllerKind === CellControllerKind.TEXT;

export const isDateControllerEntity = (
  controller: TableCellController['controller']
): controller is TableDateController =>
  controller.controllerKind === CellControllerKind.INPUT_DATE;

export const isSwitchControllerEntity = (
  controller: TableCellController['controller']
): controller is TableSwitchController =>
  controller.controllerKind === CellControllerKind.SWITCH;

export const isProgressBarControllerEntity = (
  controller: TableCellController['controller']
): controller is TableProgressBarController =>
  controller.controllerKind === CellControllerKind.PROGRESS_BAR;

export const isInputStringControllerEntity = (
  controller: TableCellController['controller']
): controller is TableInputStringController =>
  controller.controllerKind === CellControllerKind.INPUT_STRING;

export const isSelectControllerEntity = (
  controller: TableCellController['controller']
): controller is TableSelectController =>
  controller.controllerKind === CellControllerKind.SELECT;

export const isNavigationControllerEntity = (
  controller: TableCellController['controller']
): controller is TableNavigationController =>
  controller.controllerKind === CellControllerKind.NAVIGATION;
